import {
  DEFAULT_VIDEO_CHANNEL,
  DEFAULT_VIDEO_RESOLUTION,
  VIDEO_CHANNEL_RESOLUTIONS,
  getSafeVideoResolution,
} from "../constants"

export type VideoGenerationPreference = {
  model: API.Task.CreateVideoChannel
  resolution: API.VideoResolution
}

export const getVideoGenerationPreferenceFromBehavior = (
  behavior?: Partial<API.User.UserBehavior> | null,
): VideoGenerationPreference | undefined => {
  if (!behavior) return undefined

  if (behavior.video_count === 0) {
    return {
      model: DEFAULT_VIDEO_CHANNEL,
      resolution: DEFAULT_VIDEO_RESOLUTION,
    }
  }

  const model = behavior.last_video_model

  if (!model || !VIDEO_CHANNEL_RESOLUTIONS[model]) return undefined

  return {
    model,
    resolution: getSafeVideoResolution(model, behavior.last_video_resolution),
  }
}
